import { FormMapper as FormMapperComponent } from './FormMapper';
import { FORM_ELEMENT_TYPE, withContainer } from './withContainer';

const FormMapper = withContainer(FormMapperComponent);

export {
  FORM_ELEMENT_TYPE,
  FormMapper,
  FormMapperComponent,
};
export * from './withContainer';
